export default (canvas, setPlaybackHandler) => {
  let drawCompleted = false;

  const task = new Promise((resolve, reject) => {
    const ctx = canvas.getContext('2d');
    const radius = (canvas.width - 4) / 2;
    let startTime = null;

    const clear = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    };

    const easeIn = (pos) => -Math.cos(pos * (Math.PI / 2)) + 1;

    const draw = (time) => {
      if (startTime == null) {
        startTime = time;
      }

      const progress = (time - startTime) / 500;
      clear();
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.9)';
      ctx.lineWidth = '2px';

      let startPos = Math.PI / -2;
      let endPos = Math.PI / -2 + Math.PI * 2 * easeIn(progress);

      if (progress >= 1) {
        const relativeProgress = progress % 1;
        const tailSlowdown = progress < 2
          ? 2 * (1 - relativeProgress * 0.5)
          : 1;

        startPos += Math.PI * 2 * relativeProgress;
        endPos = startPos + Math.PI * tailSlowdown;
        resolve();
      }

      ctx.beginPath();
      ctx.arc(radius + 2, radius + 2, radius, startPos, endPos);
      ctx.stroke();

      if (!drawCompleted) {
        requestAnimationFrame(draw);
      } else {
        clear();
      }
    };

    setTimeout(() => {
      if (!drawCompleted) {
        requestAnimationFrame(draw);
      }
    }, 150);

    setPlaybackHandler((cancel = false) => {
      if (cancel) {
        reject();
      } else {
        drawCompleted = true;
      }
    });
  });

  task.catch(() => {
    drawCompleted = true;
  });

  return task;
};
